import { cn } from "@/lib/utils";

const SEVERITY_META = {
    green: { label: "OK", emoji: "✓", classes: "bg-emerald-500 text-white border-emerald-600", ring: "ring-emerald-500" },
    yellow: { label: "Advise", emoji: "!", classes: "bg-amber-500 text-white border-amber-600", ring: "ring-amber-500" },
    red: { label: "Urgent", emoji: "✕", classes: "bg-rose-600 text-white border-rose-700", ring: "ring-rose-600" },
    na: { label: "N/A", emoji: "–", classes: "bg-zinc-300 text-zinc-700 border-zinc-400 dark:bg-zinc-700 dark:text-zinc-100", ring: "ring-zinc-400" },
};

const ORDER = ["green", "yellow", "red", "na"];

export function SeverityPicker({ value, onChange, disabled, testidPrefix }) {
    return (
        <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Severity">
            {ORDER.map((sev) => {
                const meta = SEVERITY_META[sev];
                const active = value === sev;
                return (
                    <button
                        key={sev}
                        type="button"
                        role="radio"
                        aria-checked={active}
                        disabled={disabled}
                        onClick={() => onChange(sev)}
                        data-testid={`${testidPrefix}-sev-${sev}`}
                        className={cn(
                            "flex h-12 min-w-[68px] items-center justify-center gap-1 rounded-md border-2 px-3 text-sm font-semibold transition-all",
                            "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95",
                            disabled && "cursor-not-allowed opacity-40",
                            active
                                ? cn(meta.classes, "ring-4 ring-offset-1", meta.ring)
                                : "border-zinc-300 bg-white text-zinc-700 hover:bg-zinc-50 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-100 dark:hover:bg-zinc-800"
                        )}
                    >
                        <span className="text-base">{meta.emoji}</span>
                        <span className="text-xs">{meta.label}</span>
                    </button>
                );
            })}
        </div>
    );
}

export function SeverityChip({ severity }) {
    const meta = SEVERITY_META[severity];
    if (!meta) return null;
    return (
        <span
            className={cn(
                "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider",
                meta.classes,
            )}
        >
            <span>{meta.emoji}</span>
            <span>{meta.label}</span>
        </span>
    );
}

export { SEVERITY_META };
